<template>
	<div id="challenger-progress">
		<h2 class="progress-heading">Challenge In Progress</h2>
		<p class="progress-heading">Comparing {{ selectedDateRange }} using {{ challengerProfile.profileLabel }}</p>
		<div>
			<v-progress-linear
				rounded
				:value="progressValue"
				color="progress-color"
				class="challenger-progress-bar"
				height="css-driven"
				id="progress">
			</v-progress-linear>
			<label for="progress" class="progress-label">{{ disputesCompleted }} of {{ disputeCount }} disputes evaluated</label>
		</div>
		<p>Report Id: {{ challengerReportId }}</p>
	</div>
</template>

<script>
	/**
	 * @fileoverview challenger-progress.vue is the second of three components used for the Champion Challenger. It displays 
	 * a progress bar corresponding to the percentage of disputes that have been completed. It relies on vuex to map the state
	 * variables from the store files.
	 * 
	 * @author Sophia Frankel <sophia.frankel@quavo.com>
	 */
	import { mapState } from 'vuex';

	export default {
		data() {
			return {
			}
		},
		props: {
			/**
			 * Original profile used for the champion challenger comparison
			 */
			challengerProfile: {
				required: true,
				type: Object
			},
		},
		computed: {
			...mapState({
				challengerReportId: (state) => state.config.challengerReportId,
				challengerRange: (state) => state.config.challengerRange,
				challengerDateList: (state) => state.config.challengerDateList,
				disputesCompleted: (state) => state.config.disputesCompleted,
				disputeCount: (state) => state.config.disputeCount,
			}),
			/**
			 * Get the selected date range
			 * @returns the CC selected date range label
			 */
			selectedDateRange() {
				if (this.challengerRange !== "") {
					return this.challengerDateList.find(r => r.value === this.challengerRange).label;
				}
				return "";
			},
			/**
			 * Calculate the percent completed for CC
			 * @returns the percentage of disputes completed 
			 */
			progressValue() {
				let percent = (this.disputesCompleted / this.disputeCount) * 100;
				return percent;
			}
		},
	}
</script>

<style>

</style>